import src from "IMAGE";
export default { src, width: 240, height: 240, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAARElEQVR42o2PSwoAIAhEp6u4cyV0Ng/X8dIYCCKygbcZHT/AVguUNFwkwSCCI5mGBU6M3pqkTGWhE6enXw3livLI55sTxIwNRcauAXwAAAAASUVORK5CYII="};
